import React from 'react';
import styled from 'styled-components';
// Import icons from react-icons/fa
import {
    FaArrowRight,
    FaArrowUp,
    FaBars,
    FaCheckCircle,
    FaClock,
    FaCloud,
    FaCloudDownloadAlt,
    FaCode,
    FaDatabase,
    FaDesktop,
    FaEnvelope,
    FaFacebook,
    FaGithub,
    FaInstagram,
    FaLightbulb,
    FaLinkedin,
    FaLock,
    FaMapMarkerAlt,
    FaMobileAlt,
    FaNewspaper,
    FaPhone,
    FaPowerOff,
    FaProjectDiagram,
    FaRobot,
    FaRocket,
    FaTimes,
    FaTools,
    FaUsers
} from 'react-icons/fa';


// Create proper JSX wrapper components with type casting
export const LightbulbIcon = FaLightbulb as React.ComponentType<any>;
export const UsersIcon = FaUsers as React.ComponentType<any>;
export const CheckCircleIcon = FaCheckCircle as React.ComponentType<any>;
export const RocketIcon = FaRocket as React.ComponentType<any>;
export const MapMarkerAltIcon = FaMapMarkerAlt as React.ComponentType<any>;
export const PhoneIcon = FaPhone as React.ComponentType<any>;
export const EnvelopeIcon = FaEnvelope as React.ComponentType<any>;
export const ClockIcon = FaClock as React.ComponentType<any>;
export const InstagramIcon = FaInstagram as React.ComponentType<any>;
export const ArrowUpIcon = FaArrowUp as React.ComponentType<any>;
export const TimesIcon = FaTimes as React.ComponentType<any>;
export const BarsIcon = FaBars as React.ComponentType<any>;
export const ArrowRightIcon = FaArrowRight as React.ComponentType<any>;
export const CodeIcon = FaCode as React.ComponentType<any>;
export const MobileAltIcon = FaMobileAlt as React.ComponentType<any>;
export const DesktopIcon = FaDesktop as React.ComponentType<any>;
export const DatabaseIcon = FaDatabase as React.ComponentType<any>;
export const CloudIcon = FaCloud as React.ComponentType<any>;
export const LockIcon = FaLock as React.ComponentType<any>;
export const PowerOffIcon = FaPowerOff as React.ComponentType<any>;
export const NewspaperIcon = FaNewspaper as React.ComponentType<any>;
export const ProjectDiagramIcon = FaProjectDiagram as React.ComponentType<any>;
export const CloudDownloadIcon = FaCloudDownloadAlt as React.ComponentType<any>;
export const LinkedinIcon = FaLinkedin as React.ComponentType<any>;
export const FacebookIcon = FaFacebook as React.ComponentType<any>;
export const GithubIcon = FaGithub as React.ComponentType<any>;
export const ToolsIcon = FaTools as React.ComponentType<any>;
export const RobotIcon = FaRobot as React.ComponentType<any>;

// Custom logo component for the red power button
const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 1.8rem;
    cursor: pointer;
    height: 100%;
`;

const LogoIcon = styled.div`
    display: flex;
    align-items: center;

    img {
        height: 48px;
        width: auto;
        max-width: 160px;
        object-fit: contain; /* Verhindert Verzerrung */
    }

    @media (max-width: 768px) {
        img {
            height: 38px;
        }
    }
`;

const LogoText = styled.span`
    color: var(--text-color);

    span {
        color: var(--primary-color);
        font-weight: 800;
    }
`;

export const ByteForgeLogo: React.FC = () => {
    return (
        <LogoContainer>
            <LogoIcon>
                <img src="./images/logo.webp" alt="Firmenlogo"/>
            </LogoIcon>
            {/*<LogoText>*/}
            {/*    Byte<span>Forge</span>*/}
            {/*</LogoText>*/}
        </LogoContainer>
    );
};
